<template>
    <div :id="this.$route.name">
        <card>
            <template v-slot:content>
                <div class="row">
                    <div class="col-md-4">
                        <div class="mt-2"><i class="fas fa-user" style="color: var(--logo-color) !important"></i> &nbsp; <small id="LblName">  پرسنل : </small>[ {{ NameFam }} ]</div>
                    </div>
                    <div class="col-md-4">
                        <div class="mt-2"><i class="fas fa-building" style="color: var(--logo-color) !important"></i> &nbsp; <small id="LblName">  کارگاه : </small>[  {{WorkShopName}}  ]</div>
                    </div>
                    <div class="col-md-4">
                        <div class="mt-2"><i class="fas fa-file-user" style="color: var(--logo-color) !important"></i> &nbsp; <small id="LblName">  کد پرسنلی : </small>[  {{PersonnelCode}}  ]</div>
                    </div>
                </div>
            </template>
        </card>
        <Card back>
            <template v-slot:header>
                <h4 class="d-inline">پیوست ها</h4>
                <hr />
            </template>
            <template v-slot:content>
            <div class="row pr-4">
                <h3>
                    <i v-if="!AddMode" class="fas Pointer fa-plus text-success" @click="changeAdd"></i>
                    <i v-else class="fas fa-times Pointer text-danger" @click="changeAdd"></i>
                </h3>
            </div>
            <div v-if="AddMode" class="row">
                <div class="col-md-6">
                    <small id="LblAttachmentTypeGrp27">  دسته بندی : </small>
                    <SearchableCombo :edit="false" :code="null" :grp="27" @ResultCombo="GetAttachmentTypeGrp27" :defaultvalue="DataAxios.AttachmentTypeGrp27" :rownumintable="3" :action="'TblSalaryCombo/GetComboById'" :method="'POST'" :idinput="'BakhshNameKasreBimeAzMaliatGrp24'" :keyItem="'BakhshNameKasreBimeAzMaliatGrp24'"  :ClassProps="'required'"> </SearchableCombo>
                </div>
                <div class="col-lg-6 col-12">
                    <Uploader @upload="GetUpload"> </Uploader>
                </div>
                <hr />
                <button v-if="!editMode"  class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت اطلاعات</button>
                <button v-if="editMode" class="btn btn-danger mr-5" @click.prevent="SaveEditDeta()">ویرایش اطلاعات</button>
                
            </div>
            <div v-if="!AddMode" class="row m-2">
                <BnpGrid  v-if="$store.state.renderComponentGrid"  :propsColumn="Column" :propsRows="rows" :action="true" :hasRowNum="true" :Sortable="true" >
                        <template slot="action-slot" slot-scope="props">
                            <a href="javascript:;" title="حذف آیتم" class="mr-2 badge" @click="OnDelete(props.props)">
                                <h6><span class="fas fa-trash-alt text-secondary hover-danger"></span></h6>
                            </a>
                            <a href="javascript:;" title="اصلاح آیتم" class="mr-2 badge" @click="OnEditNew(props.props)">
                                <h6><span class="fas fa-marker text-secondary hover-warning"></span></h6>
                            </a>
                        </template>
                </BnpGrid>
            </div>
            
            </template>
        </Card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Uploader from '@/components/Uploader/Uploader.vue'

export default {
    data() {
        return {
            dataEditModeId:0,
            File: null,
            NameFam:'', 
            WorkShopName:'',
            PersonnelCode:0,
            rows:[],
            Column:[
                {
                name: 'Id',
                label: 'Id',
                visibility: false,
                },
                {
                name: 'FileName',
                label: 'نام فایل',
                visibility: true,
                },
                {
                name: 'AttachmentTypeGrp27',
                label: 'دسته بندی',
                visibility: true,
                },
                {
                name: 'FileType',
                label: 'نوع فایل',
                visibility: true,
                },
                {
                name: 'Size',
                label: 'سایز (kb)',
                visibility: true,
                },
                {
                name: 'DateTimeInsert',
                label: 'تاریخ',
                visibility: true,
                },
            ],
            AddMode:false,
            editMode:false,
            DataAxios:{ArryfildValue: {}},
            DataAxiosPost: {
                    ArryfildValue: {},
                    Method: 'post',
                    Action: '',
                    Token: this.$session.get('Token'),
                    From: 'Body',
                },
            DataAxiosUpdate: {
                ArryfildValue: {},
                Method: 'put',
                Action: '',
                Token: this.$session.get('Token'),
                From: 'Body',
            },
                Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
            DataAxiosDelete: {
                ArryfildValue: '',
                Method: 'Delete',
                Action: 'PersonnelAttachment',
                Token: this.$session.get('Token'),
            },
        }
    },
    components:{Card,BnpGrid,SearchableCombo,Uploader},
    methods:{
        GetData(){
            var DataAxois={
                ArryfildValue:{},Method: 'Get',Action: 'PersonnelAttachment/'+this.DataAxios.ArryfildValue.PersonelId,Token: this.$session.get('Token'),
            }
            this.$PostData(DataAxois).then((data) => {
                if(data!=null){
                    if(data.IsSuccess==true){
                        // console.log(data);
                        for (let index = 0; index < data.Data.length; index++) {
                            const element =  data.Data[index];
                            this.rows.push(element)
                        }
                    }
                }
          }).finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            });
        },
        changeAdd(){
        this.AddMode = !this.AddMode
        this.editMode = false
    },
    GetUpload(file) {
      this.File = file
    },
    GetAttachmentTypeGrp27(data){
            if (data.id != null) {
                    this.DataAxios.AttachmentTypeGrp27 = data.id
                }
            },
    SaveDeta() {
        var formData = new FormData()
                this.DataAxiosPost.Action = 'PersonnelAttachment'
                formData.append('File', this.File)
                formData.append('AttachmentTypeGrp27', this.DataAxios.AttachmentTypeGrp27)
                formData.append('TblPersonnelId', this.DataAxios.ArryfildValue.PersonelId)
                
                this.DataAxiosPost.ArryfildValue = formData
                this.$PostFormData(this.DataAxiosPost).then((data) => {
            if (data.IsSuccess == true) {
              this.$toasted.success('پیوست پرسنل با موفقیت ایجاد شد', {
                        action: {
                        text: 'بستن',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                        },
                        },
                    })
                        this.AddMode = !this.AddMode
                        this.$store.state.renderComponentGrid = false
                        this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                    })
                } 
                else {
                    if (data.IsSuccess == false) {
                        this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
                    }
                }
                }).finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            });
        },
        SaveEditDeta(){
            var formData = new FormData()
        this.DataAxiosUpdate.Action = 'PersonnelAttachment'
        formData.append('File', this.File)
        formData.append('AttachmentTypeGrp27', this.DataAxios.AttachmentTypeGrp27)
        formData.append('TblPersonnelId', this.DataAxios.ArryfildValue.PersonelId)
        formData.append('Id', this.dataEditModeId)
        this.DataAxiosUpdate.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosUpdate).then((data) => {
            if (data.IsSuccess == true) {
                this.$SetLog(this.DataAxios, 0)
                this.$toasted.success('اطلاعات پیوست پرسنل با موفقیت تغییر یافت', {
                  action: {
                    text: 'بستن',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    },
                  },
                }) 
                this.AddMode = !this.AddMode
                this.editMode = false
                        this.$store.state.renderComponentGrid = false
                        this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                    })
            } else {
              if (data.IsSuccess == false) {
                this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
            }
            }
        }).finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            });
        },
        OnDelete(data){
            this.$store.state.OldDataForLog = JSON.stringify(data)
            this.DataAxiosDelete.ArryfildValue = { id: data.Id }
            this.$DeleteDatapropmise(this.DataAxiosDelete, this.Sweet).then((result) => {
                if (result == true) {
                this.$store.state.renderComponentGrid = false
                var temparrayNum = this.rows.indexOf(this.rows.filter((x) => x.Id == data.Id)[0])
                this.rows.splice(temparrayNum, 1)
                this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                })
                }else{
                    console.log('Cancel');
                }
            })
        },
        OnEditNew(data){
            // console.log(data);
            this.editMode=true
            this.AddMode = !this.AddMode
            this.dataEditModeId=data.Id
        }
    },
    beforeMount(){
        this.NameFam=this.$route.params.DataRow.Name + ' '+ this.$route.params.DataRow.NamFam
        this.WorkShopName=this.$route.params.DataRow.WorkShopName
        this.PersonnelCode=this.$route.params.DataRow.PersonnelCode
        this.DataAxios.ArryfildValue.PersonelId=this.$route.params.DataRow.Id
    },
    mounted(){
            this.GetData()
        }
}
</script>
<style scoped>

</style>